import { SWRConfiguration } from 'swr'

export const swrConfig: SWRConfiguration = {
  dedupingInterval: 0,
  refreshInterval: 0,
  revalidateIfStale: false,
  revalidateOnFocus: false,
}
